<template>
  <div class="d-flex flex-wrap flex-gap">
    <v-checkbox
      v-if="listAcademic['primary'] && listAcademic['primary'].status === 'active'"
      v-model="selected"
      hide-details="auto"
      label="Cấp Tiểu Học"
      value="primary"
      class="mt-0"
    />
    <v-checkbox
      v-if="listAcademic['secondary'] && listAcademic['secondary'].status === 'active'"
      v-model="selected"
      hide-details="auto"
      label="Cấp THCS"
      value="secondary"
      class="mt-0"
    />
    <v-checkbox
      v-if="listAcademic['high'] && listAcademic['high'].status === 'active'"
      v-model="selected"
      hide-details="auto"
      label="Cấp THPT"
      value="high"
      class="mt-0"
    />
  </div>
</template>

<script>
import { AcademicLevel } from '@/plugins/api'
import { keyBy } from 'lodash'

export default {
  data: () => ({
    selected: [],
    academics: [],
    listAcademic: {},
  }),
  props: {
    defaults: {
      type: Array,
      default: () => [],
    },
    isDefaultCheckAll: {
      type: Boolean,
      default: () => true,
    },
  },
  async created() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.listAcademic = await AcademicLevel.fetch({ status: 'active' })
      console.log(this.listAcademic)
      this.listAcademic = keyBy(this.listAcademic, 'type')
      if (this.defaults && this.defaults.length) {
        this.selected = this.defaults.map(l => l.type)
      } else {
        this.academics = this.listAcademic
        if (this.isDefaultCheckAll) this.selected = ['primary', 'secondary', 'high']
        else this.selected = []
      }

      this.$emit('change', this.academics)
    },
  },

  watch: {
    selected(val) {
      this.academics = val.map(type => this.listAcademic[type])
      this.$emit('change', this.academics)
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-gap {
  gap: 16px;
}
</style>
